export default {"src":"/_next/static/media/circle-nodes-classic-solid.017f1deb.svg","height":24,"width":24};